import ConectadosPage from '../pages/ConectadosPage';
import CategoryPage from '../pages/CategoryPage';
import QuestionPage from '../pages/QuestionPage';
import { ProtectedRoute } from '../components';

export const conectadosRoutes = [
  {
    path: 'conectados',
    element: (
      <ProtectedRoute>
        <ConectadosPage />
      </ProtectedRoute>
    )
  },
  {
    path: 'conectados/:category',
    element: (
      <ProtectedRoute>
        <CategoryPage />
      </ProtectedRoute>
    )
  },
  {
    path: 'conectados/:category/:subcategory/question',
    element: (
      <ProtectedRoute>
        <QuestionPage />
      </ProtectedRoute>
    )
  }
]; 